<template>
  <q-list id="appt-types-panel">
    <q-item-wrapper
      icon="mdi-format-list-bulleted-type"
      label="What type of appointment is this?"
      label-class="text-subtitle2"
      dense
      class="q-mb-sm invisible-item"
    />

    <div class="q-px-md">
      <TypesPopover
        ref="popover"
        :model-value="event.types"
        dense
        outlined
        multiple
        placeholder="Find Appointment Types..."
        display="item"
        icon="mdi-magnify"
        :hide-on-first-click="event.types.length < 1"
        :can-create="can(permissions.canModifyCompanyDetails)"
        :with-deleted="false"
        @clicked-result="addType"
        @removed-result="removeType"
      />
    </div>

    <tip
      name="moduleAppointmentsLearnTypes"
      wrapper-class="q-px-md q-py-sm"
      label="Appointment Types can be used to quickly prefill common details onto new appointments."
      :inline-actions="false"
    >
      <template #action>
        <q-btn
          no-caps
          color="white"
          size="12px"
          text-color="black"
          label="Learn More"
          @click="$bus.emit('help:search', 'appointment type')"
        />
      </template>
    </tip>
  </q-list>
</template>

<script>
import TypesPopover from '../../../types/TypesPopover.vue'
import typesMixin from '../../mixins/typesMixin'

export default {
  components: {
    TypesPopover
  },
  mixins: [typesMixin],
  props: {
    event: {
      required: true,
      type: Object
    },
    errors: {
      type: Object,
      default: () => {
        return {}
      }
    },
    prefillDate: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    addType (item) {
      this.baseAddType(this.event, item, this.prefillDate)
    },
    removeType (item) {
      this.baseRemoveType(this.event, item)
    }
  },
  mounted () {
    if (this.event.types.length < 1) {
      this.timed(() => {
        if (!this.$refs.popover) {
          return
        }
        this.$refs.popover.focus()
      }, this.$q.platform.is.mobile ? 750 : 500)
    }
  }
}
</script>
